import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import FolderZipOutlinedIcon from '@mui/icons-material/FolderZipOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Button, Toolbar, Tooltip, Typography } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import React, { useContext, useState } from 'react';
import { RiDeleteBinLine, RiFolderTransferLine } from 'react-icons/ri';
import { useDispatch, useSelector } from 'react-redux';
import { MediaContext } from '../../../..';
import { LanguageContext } from '../../../../../../libs/Context';
import { MuiPaperProps } from '../../../../../../libs/HelperContent';
import { setDownloadFile, setZipFile } from '../../../../../../redux/MediakitRedux';
import DeletePopUp from '../../../../Common/DeletePopUp/DeletePopUp';
import MoveToTrashPopUp from '../../../../Common/MoveToTrashPopUp/MoveToTrashPopUp';
import MoveToFolder from '../../../MoveToFolder';
import { useNavigate, useParams } from 'react-router-dom';
import EditBrshSvg from '../../../../../../assets/SvgComponents/EditBrshSvg';
import SelectTemplate from '../../../CustomEdmTemplates/SelectTemplate';

const MediaKitTableToolbar = (props) =>
{
	const { getTrashDataInfo, getFoldersData } = props;
	const { language } = useContext(LanguageContext);
	const session:any = useSelector((state:any) => state?.mysession?.session);
	const [ anchorEl, setAnchorEl ] = useState<any>(null);
	const userData = useSelector((state:any) => state?.mysession?.session);
	const { mediaState, tab } = useContext(MediaContext);
	const open = Boolean(anchorEl);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const tabVal:any = useParams()?.tab || '';
	const folderId = useParams()?.id || '';
	const clickedUser = useParams()?.userId || '';

	const [ popups, setPopups ] = useState<any>({
		move      : false,
		restore   : false,
		rename    : false,
		share     : false,
		trash     : false,
		delete    : false,
		customize : false

	});

	const handlePopup = (item) =>
	{
		setPopups({ ...popups, ...item });
	};
	const handleMove = () =>
	{
		setPopups({ ...popups, move: true });
	};
	const handleClose = () =>
	{
		setAnchorEl(null);
	};
	const handleClick = (event) =>
	{
		setAnchorEl(event.currentTarget);
	};
	const handleZippedFile = () =>
	{
		dispatch(setZipFile(mediaState?.selectedData));
	};

	const clickDownload = () =>
	{
		dispatch(setDownloadFile(mediaState?.selectedData));
	};

	const isFolderSelected = mediaState?.selectedData?.find((item) => item?.type === 0);
	const checkEditAccess = mediaState?.selectedData?.some((each:any) =>
		each?.shareAccess === 3);
	const checkCreatedBy = mediaState?.selectedData?.find((each:any) =>
	{ return each?.createdBy; });
	const fileTypesArray = mediaState?.selectedData?.length > 0 && mediaState?.selectedData.map((each) => each?.media?.type?.split('/')[1]);

	const show = {
		edit   : [ 0, 1, 2, 4 ].includes(tab) && mediaState?.selectedData?.length === 1 && mediaState?.selectedData[0]?.media?.type && mediaState?.selectedData[0]?.media?.type?.split('/')[0] === 'image',
		zip    :	[ 0, 1, 2 ].includes(tab) && !fileTypesArray?.includes('zip'),
		moveto : tab === 0 || tab === 2,
		delete : tab === 3 || (tab === 1 && checkEditAccess &&
			checkCreatedBy === userData?.userId),
		restore     : tab === 3,
		movetotrash : tab === 0 || (tab === 2 && session?.empRole === 'superAdmin') || (tab === 1 && checkEditAccess && checkCreatedBy?.createdBy === userData?.userId) || tab === 4,
		download   	: [ 0, 1, 2 ].includes(tab) && !isFolderSelected
	};

	const handleNavigate = () =>
	{
		if (tab === 4)
		{
			navigate(`/drive/design/${tabVal}/${mediaState?.selectedData[0]?.folderId}/${'edit'}`);
		}
		else
		{
			navigate(folderId ? `/drive/edit/${tabVal}/${window.btoa(mediaState?.selectedData[0]?.media?.key)}/${mediaState?.selectedData[0]?.folderId}` : `/drive/edit/${tabVal}/${window.btoa(mediaState?.selectedData[0]?.media?.key)}`);
		}
	};

	return (
		<>
			<Toolbar
				sx={{
					backgroundColor : '#e4f4f8',
					pl              : { sm: 2 },
					pr              : { xs: 1, sm: 1 }
				}}
			>
				<div className='flexRow'>
					<div className='flexMinWidthRow alignCntr'>
						<Typography color='inherit' variant='subtitle1' component='div'>
							<div className='subHeadingSM capitalTxt'>
								<span>{mediaState?.selectedData?.length}</span>
								<span className='pdngLXS'>{language.selected}</span>
							</div>
						</Typography>
					</div>
					<div className='webSearch'>
						{show?.edit &&
						<div className='pdngHXS'>
							<Tooltip title={language?.customize} onClick={handleNavigate}>
								<Button
									color='primary'
									size='small'
									variant='outlined'
									disableElevation
									tabIndex={0}
									onKeyUp={(e) => { e.key === 'Enter' && handlePopup({ customize: true }); }}
									disableRipple
									onClick={() => handlePopup({ customize: true })}
								>
									<EditBrshSvg className='invertPrimary'/>
									<span className='pdngHXS'>{language.customize}</span>
								</Button>
							</Tooltip>
						</div>
						}
						{show?.download &&
						<div className='pdngHXS'>
							<Tooltip title={language?.download} onClick={clickDownload}>
								<Button
									color='primary'
									size='small'
									variant='outlined'
									disableElevation
									tabIndex={0}
									onKeyUp={(e) => { e.key === 'Enter' && clickDownload(); }}
									disableRipple
									onClick={clickDownload}
								>
									<FileDownloadOutlinedIcon />
									<span className='pdngHXS'>{language.download}</span>
								</Button>
							</Tooltip>
						</div>
						}
						{show?.zip &&
						<div className='pdngHXS'>
							<Tooltip title={language?.zip}>
								<Button
									color='primary'
									size='small'
									variant='outlined'
									disableElevation
									disableRipple
									tabIndex={0}
									onKeyUp={(e) => { e.key === 'Enter' && handleZippedFile(); }}
									onClick={handleZippedFile}
								>
									<FolderZipOutlinedIcon />
									<span className='pdngHXS'>{language.zip}</span>
								</Button>
							</Tooltip>
						</div>
						}
						{show?.moveto && <div className='pdngHXS'>
							<Tooltip title={language?.moveto}>
								<Button
									color='primary'
									size='small'
									variant='outlined'
									disableElevation
									disableRipple
									tabIndex={0}
									onKeyUp={(e) => { e.key === 'Enter' && handleMove(); }}
									onClick={handleMove}
								>
									<RiFolderTransferLine fontSize={'var(--pixel18)'} />
									<span className='pdngHXS'>{language.moveto}</span>
								</Button>
							</Tooltip>
						</div>}

						{show?.movetotrash && <div className='pdngHXS'>
							<Tooltip title={language.trash}>
								<Button
									color='primary'
									size='small'
									variant='outlined'
									disableElevation
									disableRipple
									tabIndex={0}
									onKeyUp={(e) => { e.key === 'Enter' && handlePopup({ trash: true }); }}
									onClick={() => handlePopup({ trash: true })}
								>
									<RiDeleteBinLine fontSize={'var(--pixel18)'} />
									<span className='pdngHXS'>{language.trash}</span>
								</Button>
							</Tooltip>
						</div>}
						{show?.delete && <div className='pdngHXS'>
							<Tooltip title={language?.delete}>
								<Button
									color='primary'
									size='small'
									variant='outlined'
									disableElevation
									disableRipple
									tabIndex={0}
									onKeyUp={(e) => { e.key === 'Enter' && handlePopup({ delete: true }); }}
									onClick={() => handlePopup({ delete: true })}
								>
									<RiDeleteBinLine fontSize={'var(--pixel18)'} />
									<span className='pdngHXS'>{language?.delete}</span>
								</Button>
							</Tooltip>
						</div>
						}
					</div>
					<div className='flexAutoRow mobSearch'>
						{show?.download && <div className=''>
							<Tooltip title={language?.download}>
								<Button
									color='primary'
									size='small'
									variant='outlined'
									disableElevation
									tabIndex={0}
									onKeyUp={(e) => { e.key === 'Enter' && clickDownload(); }}
									onClick={clickDownload}
									disableRipple
								>
									<FileDownloadOutlinedIcon />
								</Button>
							</Tooltip>
						</div>}
						<div className='mrgnHXS'>
							<Tooltip title={language?.moreOption}>
								<Button
									color='primary'
									size='small'
									variant='outlined'
									disableElevation
									disableRipple
									tabIndex={0}
									onKeyUp={(e) => { e.key === 'Enter' && handleClick(e); }}
									onClick={handleClick}
								>
									<MoreVertIcon />
								</Button>
							</Tooltip>
							<Menu
								id='basic-menu'
								anchorEl={anchorEl}
								open={open}
								onClose={handleClose}
								PaperProps={MuiPaperProps}
							>
								{show?.edit && <MenuItem value='edit' tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handlePopup({ customize: true }); }} onClick={() => handlePopup({ customize: true })}>
									<EditBrshSvg className='menuIcon'/>&nbsp; {language.customize}
								</MenuItem>}
								{show?.zip && <MenuItem value='zip' tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleZippedFile(); }} onClick={handleZippedFile}>
									<FolderZipOutlinedIcon className='menuIcon' />&nbsp; {language.zip}
								</MenuItem>}
								{show?.moveto && <MenuItem value='MoveTo' tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handleMove(); }} onClick={handleMove}>
									<RiFolderTransferLine className='menuIcon' />&nbsp; {language.moveto}
								</MenuItem>}
								{ show?.movetotrash && <MenuItem value='Trash' tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handlePopup({ trash: true }); }} onClick={() => handlePopup({ trash: true })}>
									<RiDeleteBinLine className='menuIcon'/>&nbsp; {language?.trash}
								</MenuItem>}
								{show?.delete && <MenuItem value='delete' tabIndex={0} onKeyUp={(e) => { e.key === 'Enter' && handlePopup({ delete: true }); }} onClick={() => handlePopup({ delete: true })}>
									<RiDeleteBinLine className='menuIcon' />&nbsp; {language.delete}
								</MenuItem>}
							</Menu>
						</div>
					</div>
				</div>
				{popups?.move && <MoveToFolder popups={popups} handlePopup={handlePopup} />}

			</Toolbar>
			{popups?.delete &&
			<DeletePopUp
				handlePopup={handlePopup}
				getFoldersData={getFoldersData}
				folderData={mediaState}
			/>
			}
			{popups?.trash &&
			<MoveToTrashPopUp
				handlePopup={handlePopup}
				getTrashDataInfo={getTrashDataInfo}
			/>
			}
			{popups?.customize &&
			<SelectTemplate
				handlePopup={handlePopup}
				popups={popups?.customize}
				from='edit'
				data={mediaState?.selectedData?.length > 0 ? mediaState?.selectedData[0] : {}}
				clickedUser={clickedUser}
			/>}
		</>
	);
};

export default MediaKitTableToolbar;
